import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Image from "components/Elements/Image/Image.tsx";
import SideBarContentHolder from "../../Reusable/SideBar/SideBarContentHolder.js";
import Button from "components/Elements/Button/Button.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import loader from "helpers/loaderUrl.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useMail } from "contexts/mailContext/mailContext.js";
import { useSideBar } from "../../../contexts/sideBarContext/sideBarContext.js";
import { useToasts } from "react-toast-notifications";

export const DeleteMailInnerComponent = () => {
  const { getTextByKey } = useContent();
  const { getMailId, getMailStatus, setDeleteParam, getDeleteParam } =
    useMail();
  const { addToast } = useToasts();
  const { deleteMailParams: deleteParam } = useParams();
  const [displayUndoText, setDisplayUndoText] = useState(
    getMailStatus() === "removed"
  );
  const [loading, setLoading] = useState(false);

  const deleteJumboFormMailBySender = async (undo = false) => {
    setLoading(true);
    const body = {
      encryptedMailId: getMailId(),
      encryptedMailIdAndSenderMail: deleteParam || getDeleteParam(),
      undo: undo,
    };
    const response = await apiRequest(
      "Mails",
      "RemoveJumboFormMailBySender",
      body,
      "POST"
    );

    if (response.status === "success") {
      //add /delete/${deleteParam} to url and do redirect
      if (response.data === "ok") {
        const thisUrl = window.location.href;
        // check if url already has /delete/ or deletParam is different from the current url
        if (!thisUrl.includes(`/delete/`)) {
          const newUrl = thisUrl + `/delete/${deleteParam}`;
          window.location.href = newUrl;
        } else {
          window.location.href = thisUrl;
        }
      } else {
        //display the response.data as error in toast
        addToast(getTextByKey(response.data), {
          appearance: "error",
        });
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    return () => {
      setDeleteParam(null);
    };
  }, []);

  return (
    <div className="delete-mail-inner">
      {displayUndoText ? (
        <div className="delete-mail-content undo">
          <p className="delete-mail-text">
            {getTextByKey("delete-mail-text-undo")}
          </p>
          <p
            className="as-link"
            disabled={loading}
            onClick={() => deleteJumboFormMailBySender(true)}
          >
            {loading ? <Image src={loader} /> : getTextByKey("undo-link")}
          </p>
        </div>
      ) : (
        <div className="delete-mail-content">
          <h5>{getTextByKey("delete-mail-title")}</h5>
          <p className="delete-mail-text">{getTextByKey("delete-mail-text")}</p>
          <Button
            className="new-button"
            onClick={() => deleteJumboFormMailBySender(false)}
            disabled={loading}
            img={{
              src: loading ? loader : null,
              title: loading ? "loader" : null,
            }}
            title={!loading ? getTextByKey("confirm-and-delete") : null}
          />
        </div>
      )}
    </div>
  );
};

const DeleteMailAction = ({ itemId, lightBox }) => {
  const { setSideBar } = useSideBar();
  const { getTextByKey } = useContent();

  const handleClick = () => {
    setSideBar(
      <SideBarContentHolder
        headerName={getTextByKey("sidebar-delete-mail-header")}
        headerIcon={"trash-solid-b"}
      >
        <DeleteMailInnerComponent />
      </SideBarContentHolder>
    );
  };

  return (
    <Tooltip tooltipTextKey="delete-icon-tooltip-text" top>
      <Icon name="trash" onClick={handleClick} gray clickable />
    </Tooltip>
  );
};

export default DeleteMailAction;
